import axios from 'axios'
import {getAdminToken} from '../auth/_requests'

const API_URL = process.env.REACT_APP_API_URL

const adminApi = axios.create({withCredentials: true})
adminApi.interceptors.request.use((config) => {
  const token = getAdminToken()
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export interface PayoutCustomer {
  _id: string
  name: string
  email: string | null
  phone: string | null
  connected_at: string
  revenue: number // lifetime, NIS
}

export interface AffiliatePayoutRow {
  affiliate_id: string
  affiliate_name: string
  affiliate_email: string | null
  affiliate_phone: string | null
  affiliate_code: string | null
  count: number
  amount: number
  revenue_total: number // lifetime income from every customer this affiliate referred
  revenue_month: number // of which, received during the selected month
  paying_customers: number
  paid: boolean
  paid_at: string | null
  customers: PayoutCustomer[]
}

export interface PayoutTotals {
  affiliates: number
  connections: number
  owed: number
  paid: number
  unpaid: number
  revenue_total: number // summed over the affiliates listed for the month
  revenue_month: number
  revenue_all_time: number // every referred customer, whatever month they connected
  revenue_all_month: number
  paying_customers: number
}

export interface AffiliatePayoutsResponse {
  success: boolean
  month: string // YYYY-MM
  rate: number
  available_months: string[]
  affiliates: AffiliatePayoutRow[]
  totals: PayoutTotals
}

export function getAffiliatePayouts(params?: {month?: string; rate?: number}): Promise<{data: AffiliatePayoutsResponse}> {
  return adminApi.get(`${API_URL}/admin/affiliate-payouts`, {params})
}

export function markAffiliatePaid(body: {affiliate_id: string; month: string; rate?: number; note?: string}): Promise<{data: {success: boolean}}> {
  return adminApi.post(`${API_URL}/admin/affiliate-payouts/mark-paid`, body)
}

export function unmarkAffiliatePaid(body: {affiliate_id: string; month: string}): Promise<{data: {success: boolean}}> {
  return adminApi.post(`${API_URL}/admin/affiliate-payouts/unmark-paid`, body)
}
